import { render, staticRenderFns } from "./m-addBanner.vue?vue&type=template&id=dbdd51be&"
import script from "./m-addBanner.vue?vue&type=script&lang=js&"
export * from "./m-addBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports